export default __webpack_public_path__ + "media/images/features/jtb/overline-20d190e6fe0659553d3ebb419c0c8507.png";